import WPAccordion from "./WPAccordion";

export default WPAccordion;
